export const RECEIVE_SAVED_SEARCHES_DATA = 'RECEIVE_SAVED_SEARCHES_DATA';
export const ADD_SAVED_SEARCH = 'ADD_SAVED_SEARCH';
export const REMOVE_SAVED_SEARCH = 'REMOVE_SAVED_SEARCH';
